import { localStorageGet, localStorageSet } from '@/lib/EnsLocalStorage';

export const GetOfferRequestProcessSetting = localStorageGet;

export const SetOfferRequestProcessSetting = localStorageSet;
